// extracted by mini-css-extract-plugin
export default {"title_container":"card-title_title_container__GN6z2","small_view":"card-title_small_view__WWkTB","title":"card-title_title__M4Qdq","no_entity":"card-title_no_entity__lZIGt"};